const getFullName = (person): string => {
  const {
    name: { value: nameVal = '' },
    surname: { value: surnameVal = '' },
    patronymic: { value: patronymicVal = '' },
    isPatronymicAbsent: { value: isPatronymicAbsentVal = false },
  } = person;
  const patronymicValue = isPatronymicAbsentVal ? '' : patronymicVal;
  return [surnameVal, nameVal, patronymicValue]
    .filter((name) => !!name)
    .join(' ');
};

export default getFullName;
